export var findAccountingMethodBasedOnBu = function findAccountingMethodBasedOnBu() {
  var accountingMethodMetaData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return accountingMethodMetaData.length > 1 ? accountingMethodMetaData[1].AdditionalProperties : accountingMethodMetaData[0].AdditionalProperties;
};